import { CREATE_CATEGORY_GROUP } from '../config';

export default function (state = null, action) {
    switch (action.type) {
        case CREATE_CATEGORY_GROUP:
            return action.payload;
        default:
            return state;
    }
}
